/**
 * Krav:
 * Ta emot en lista av olika telefonnummer, ex hemtelefon och mobil
 * Skrota alla specialtecken utom 0-9 samt + och se till att man har en längd
 * Använd första bästa telefonnummer som uppfyller detta
 * Om tecknet börjar med + så ska grupperingen av tecken lyda "3, 2, 3, resterande 2"
 * Om tecknet inte börjar med + så ska grupperingen av tecken lyda "4, resterande 2"
 */
export class PhoneFormatter {

    private static readonly PLUS_START_CHUNK_STRATEGY = [
        3,
        2,
        3,
        2
    ];
    private static readonly DEFAULT_START_CHUNK_STRATEGY = [
        4,
        2
    ];
    /**
     * Returnerar ett formaterat telefonnummer baserat på flera möjliga telefonnummer
     * Tar bort alla tecken utom 0-9 samt "+" och formaterar det enligt ett regelverk
     *
     * @param phoneNumbers En lista med telefonnummer ordnat i enligt mest önskat till minst önskat
     */
    static renderPhonePresentation(phoneNumbers: string[]): string {

        const suitableNumber = this.getBestSuitablePhoneNumber(phoneNumbers);
        return this.formatSuitableNumber(suitableNumber);
    }

    private static getBestSuitablePhoneNumber(phoneNumbers: string[]) {
        for (const phone of phoneNumbers) {
            if (!phone) {
                continue;
            }
            if (typeof phone !== "string") {
                continue;
            }
            // Tar bort alla tecken utom 0-9 samt +
            const preCandidate = phone.replace(/[^0-9+]+/g, "");
            if (preCandidate) {
                return preCandidate;
            }
        }
        return "";
    }

    private static formatSuitableNumber(suitableNumber: string): string {
        if (!suitableNumber) {
            return "";
        }
        const chunks = this.getChunked(suitableNumber);

        return chunks.filter(x => !!x).join(" ");
    }

    private static getChunked(text: string) {
        if (text.startsWith("+")) {
            return this.getChunkedByStrategy(text, this.PLUS_START_CHUNK_STRATEGY);
        } else {
            return this.getChunkedByStrategy(text, this.DEFAULT_START_CHUNK_STRATEGY);
        }
    }

    /**
     * Delar upp en sträng i bestämda längder
     * Ex:
     * "ABCDEFGHIJK", [2,3,2,1] returnerar arrayen ["AB","CDE","FG","H","I","J","K"]
     *
     * @param text Texten att splitta i chunks
     * @param chunkLengths En lista av nummer som bestämmer chunklängden i ordning, sista används i fortsättningen.
     * @returns Chunks
     */
    private static getChunkedByStrategy(text: string, chunkLengths: number[]): string[] {
        let charsUsed = 0;
        const remainingLength = text.length;
        const chunks = [];

        let chunkIndex = 0;
        while (charsUsed < remainingLength) {
            // Hämta nästa chunkSize, om den inte finns så tas den sista
            const chunkLength = chunkLengths.length > chunkIndex ? chunkLengths[chunkIndex] : chunkLengths[chunkLengths.length-1];
            chunks.push(text.substring(charsUsed, charsUsed+chunkLength));
            charsUsed += chunkLength;
            chunkIndex++;
        }

        return chunks;
    }

}
